import React, {useState, useEffect, useCallback} from 'react'
import './../../App.css';
import './Reports.css';
import axios from 'axios';
import {token, domain} from '../Security';
import { PDFDocument, rgb, StandardFonts } from "pdf-lib";
import loadingSpinner from './../../assets/loading.gif';
import { format } from 'date-fns';
//icons
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

function CostCenterReport({user, isHideSideMenu}) {
    const [payrollPeriodId, setPayrollPeriodId] = useState("");
    const [payrollPeriodDescription, setPayrollPeriodDescription] = useState("");
    const [companyId, setCompanyId] = useState(0);
    const [company, setCompany] = useState(null);
    const [errorState, setErrorState] = useState(false);
    const [loading, setLoading] = useState(false);
    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end

    const numberWithCommasAndDecimal = (number) => {
        if(!number){
            return "0.00";
        }
        return number.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };
    function base64ToUint8Array(base64String) {
        const byteCharacters = atob(base64String); // Decode Base64
        const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i));
        return new Uint8Array(byteNumbers);
    }
    const writeFont7Black = ({page, font, x, y, text}) => {
        page.drawText(text, {
            x: x,  // Adjust X position
            y: y,  // Adjust Y position
            size: 7, 
            font: font,
            color: rgb(0, 0, 0), // Black text
        })
    }
    const writeFont8Black = ({page, font, x, y, text}) => {
        page.drawText(text, {
            x: x,  // Adjust X position
            y: y,  // Adjust Y position
            size: 8, 
            font: font,
            color: rgb(0, 0, 0), // Black text
        })
    }

    const modifyAndDownloadPDF = useCallback(async (data) => {
        if (data.length <= 0) {
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage("No records found");
            return;
        }

        setLoading(true);
        console.log(data)

        try {
            // Load the existing PDF template
            const pdfUrl = `${window.location.origin}/docs/Cost_Center.pdf`;
            const response = await fetch(pdfUrl);
            const pdfBytes = await response.arrayBuffer();
            const pdfDoc = await PDFDocument.load(pdfBytes);
            const templatePdf = await PDFDocument.load(pdfBytes); // Load again for copying
            const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
            const fontBold = await pdfDoc.embedFont(StandardFonts.HelveticaBold);

            for (let deptIndex = 0; deptIndex < data.length; deptIndex++) {
                let page = pdfDoc.getPages()[0]; // Get first page

                if(deptIndex > 0){
                    const [templatePage] = await pdfDoc.copyPages(templatePdf, [0]);
                    page = pdfDoc.addPage(templatePage);
                }

                let pageCount = 1;

                writeFont7Black({ page, font, x: 455, y: 20, text: `Page ${pageCount}` });

                //611 height

                const _dateToday = new Date().toISOString().split("T")[0];

                // Embed Company Logo
                if(company?.logo){
                const companyLogoBinary = base64ToUint8Array(company.logo);
                const companyLogo = await pdfDoc.embedPng(companyLogoBinary);
                page.drawImage(companyLogo, { x: 10, y: 500, width: 200, height: 100 });
                }
                
                writeFont8Black({ page, font, x: 770, y: 567, text: `${_dateToday}` });
                writeFont8Black({ page, font, x: 770, y: 545, text: `${user.employeePersonalInformationFullName}` });
                writeFont8Black({ page, font, x: 80, y: 475, text: `${payrollPeriodDescription}` });
                writeFont8Black({ page, font, x: 38, y: 450, text: `Cost Center: ${data[deptIndex].costCenterDescription}` });

                const startX_item_1 = 40;
                const startX_item_2 = 180;
                const startX_item_3 = 257;
                const startX_item_4 = 323;
                const startX_item_5 = 388;
                const startX_item_6 = 455;
                const startX_item_7 = 540;
                const startX_item_8 = 625;
                const startX_item_9 = 720;
                const startX_item_10 = 830;
                let startY = 370;
                const lineSpacing = 80;
                const minY = 50; // Prevents writing too low

                let totalBasicPay = 0;
                let totalGrossPay = 0;
                let totalNetPay = 0;
                let totalSSS = 0;
                let totalPhilhealth = 0;
                let totalPagibig = 0;
                let totalEmployerSSS = 0;
                let totalEmployerPhilhealth = 0;
                let totalEmployerPagibig = 0;

                for (let index = 0; index < data[deptIndex].employees.length; index++) {
                    const item = data[deptIndex].employees[index];

                    if (startY - lineSpacing < minY) {
                        pageCount += 1;

                        const [templatePage] = await pdfDoc.copyPages(templatePdf, [0]);
                        page = pdfDoc.addPage(templatePage);
                        startY = 370; // Reset Y position

                        // Embed Company Logo
                        if(company?.logo){
                        const companyLogoBinary = base64ToUint8Array(company.logo);
                        const companyLogo = await pdfDoc.embedPng(companyLogoBinary);
                        page.drawImage(companyLogo, { x: 10, y: 500, width: 200, height: 100 });
                        }
                        
                        writeFont8Black({ page, font, x: 770, y: 567, text: `${_dateToday}` });
                        writeFont8Black({ page, font, x: 770, y: 545, text: `${user.employeePersonalInformationFullName}` });
                        writeFont8Black({ page, font, x: 80, y: 475, text: `${payrollPeriodDescription}` });
                        writeFont8Black({ page, font, x: 38, y: 450, text: `Cost Center: ${data[deptIndex].costCenterDescription}` });

                        writeFont7Black({ page, font, x: 455, y: 20, text: `Page ${pageCount}` });
                    }
                
                    // Write employee data
                    writeFont7Black({ page, font, x: startX_item_1, y: startY, text: `${item.employeePersonalInformationEmployeeId}` });
                    writeFont7Black({ page, font, x: startX_item_1, y: startY - 20, text: `${item.employeePersonalInformationFullName}` });
                    writeFont7Black({ page, font, x: startX_item_2, y: startY, text: `${numberWithCommasAndDecimal(item.basicPay)}` });
                    writeFont7Black({ page, font, x: startX_item_3, y: startY, text: `${numberWithCommasAndDecimal(item.grossPay)}` });
                    writeFont7Black({ page, font, x: startX_item_4, y: startY, text: `${numberWithCommasAndDecimal(item.netPay)}` });
                    writeFont7Black({ page, font, x: startX_item_5, y: startY, text: `${numberWithCommasAndDecimal(item.sss)}` });
                    writeFont7Black({ page, font, x: startX_item_6, y: startY, text: `${numberWithCommasAndDecimal(item.philhealth)}` });
                    writeFont7Black({ page, font, x: startX_item_7, y: startY, text: `${numberWithCommasAndDecimal(item.pagibig)}` });
                    writeFont7Black({ page, font, x: startX_item_8, y: startY, text: `${numberWithCommasAndDecimal(0)}` });
                    writeFont7Black({ page, font, x: startX_item_9, y: startY, text: `${numberWithCommasAndDecimal(0)}` });
                    writeFont7Black({ page, font, x: startX_item_10, y: startY, text: `${numberWithCommasAndDecimal(0)}` });
                    
                    writeFont7Black({ page, font, x: 40, y: startY - 55, text: `_____________________________________________________________________________________________________________________________________________________________________________________________________________________________` });
                
                    totalBasicPay += item.basicPay;
                    totalGrossPay += item.grossPay;
                    totalNetPay += item.netPay;
                    totalSSS += item.sss;
                    totalPhilhealth += item.philhealth;
                    totalPagibig += item.pagibig;

                    startY -= lineSpacing; // Move to next row
                }

                writeFont7Black({ page, fontBold, x: 40, y: startY, text: `TOTAL` });
                writeFont7Black({ page, fontBold, x: startX_item_2, y: startY, text: `${numberWithCommasAndDecimal(totalBasicPay)}` });
                writeFont7Black({ page, fontBold, x: startX_item_3, y: startY, text: `${numberWithCommasAndDecimal(totalGrossPay)}` });
                writeFont7Black({ page, fontBold, x: startX_item_4, y: startY, text: `${numberWithCommasAndDecimal(totalNetPay)}` });
                writeFont7Black({ page, fontBold, x: startX_item_5, y: startY, text: `${numberWithCommasAndDecimal(totalSSS)}` });
                writeFont7Black({ page, fontBold, x: startX_item_6, y: startY, text: `${numberWithCommasAndDecimal(totalPhilhealth)}` });
                writeFont7Black({ page, fontBold, x: startX_item_7, y: startY, text: `${numberWithCommasAndDecimal(totalPagibig)}` });
                writeFont7Black({ page, fontBold, x: startX_item_8, y: startY, text: `${numberWithCommasAndDecimal(totalEmployerSSS)}` });
                writeFont7Black({ page, fontBold, x: startX_item_9, y: startY, text: `${numberWithCommasAndDecimal(totalEmployerPhilhealth)}` });
                writeFont7Black({ page, fontBold, x: startX_item_10, y: startY, text: `${numberWithCommasAndDecimal(totalEmployerPagibig)}` });
            }

            setShowRequestMessage(true);
            setIsSuccess(true);

            // Save and Download PDF
            const modifiedPdfBytes = await pdfDoc.save();
            const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });

            const a = document.createElement("a");
            a.href = URL.createObjectURL(blob);
            a.download = `Cost_Center.pdf`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(a.href);
        } catch (error) {
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error("Error:", error);
            setRequestMessage("Error processing PDF");
        }

        setLoading(false);
    }, [user, payrollPeriodDescription, company]);
    
    const fetchDataCompany = useCallback(async () => {
        const apiUrl =  domain + `/api/Company/${companyId}`;

        try {
            const response = await axios.get(apiUrl , {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json' // You can include other headers if needed
            }})
            
            return response.data;
        } catch (error) {
            return null
        }
    }, [companyId]);

    const fetchData = useCallback(async () => {
        const apiUrl =  domain + `/api/Reports/cost-center/payroll-period/${payrollPeriodId}`;

        try {
            setLoading(true);
            const response = await axios.get(apiUrl , {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json' // You can include other headers if needed
            }})

            const _company = await fetchDataCompany();
            setCompany(_company)

            modifyAndDownloadPDF(response.data);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }, [fetchDataCompany, modifyAndDownloadPDF, payrollPeriodId]);

    const generate = () =>{
        if(!payrollPeriodId
            || !company
        ){
            setErrorState(true);
            return;
        }
        setErrorState(false);
        fetchData();
    };

    return (
        <div>
            <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
                <div className="LeftSpace"></div>
                <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
                    <div className="ReportsInfo shadow-xl">
                        <div className="reports-header">
                            <div className='sub-title row'>
                                <span style={{padding:"0 5px 0 0", color:"#b0b0b0"}}>{"Reports >"} </span>
                                <span style={{borderBottom:"1px solid black"}}>{"Cost Center"}</span>
                            </div>
                            <h3>Generate Cost Center Report</h3>
                        </div>
                        <div className="reports-body">
                            <div className="info-item-holder row" style={{alignItems: "center", justifyContent: "normal"}}>
                                <div className="info-item3 info-item column">
                                    <div className="info-item-label" style={{fontWeight:"normal", fontSize:"14px"}}>Payroll Period</div>
                                    <div className="info-item-input">
                                        <PayrollPeriodIdSelect payrollPeriodId={payrollPeriodId} setPayrollPeriodId={setPayrollPeriodId} setPayrollPeriodDescription={setPayrollPeriodDescription}/>
                                    </div>
                                    <span style={{
                                                visibility: !payrollPeriodId && errorState ? "visible" : "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                                <div className="info-item3 info-item column">
                                    <div className="info-item-label" style={{fontWeight:"normal", fontSize:"14px"}}>Company</div>
                                    <div className="info-item-input">
                                        <CompanyTypeSelect companyId={companyId} setCompanyId={setCompanyId} setCompany={setCompany}/>
                                    </div>
                                    <span style={{
                                                visibility: !companyId && errorState ? "visible" : "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="reports-footer">
                            <div className="buttons row">
                                <button id="activeEmployeesGenerate"
                                    className="generate row" 
                                    onClick={generate}
                                    > GENERATE
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {loading? (
            <div
                style={{
                position: "fixed",
                top: "0",
                left: "0",
                width: "100vw",
                height: "100vh",
                zIndex: "2000",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                backgroundColor: "#ffffff59",
                }}
            >
                <img src={loadingSpinner} alt="Loading..." />
            </div>
            ) : (
                <></>
                )
            }
        </div>
    )
}

function PayrollPeriodIdSelect({payrollPeriodId, setPayrollPeriodId, setPayrollPeriodDescription}){
    const [isSelected, setIsSelected] = useState(false);
    
    const [payrollPeriodIds, setPayrollPeriodIds] = useState([]);

    const fetchData = async () => {
        //const currentYear = new Date().getFullYear();
        //const apiUrl =  domain + `/api/PayrollPeriod/year/${currentYear}`;
        const apiUrl =  domain + `/api/PayrollPeriod/active`; // changed

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            setPayrollPeriodIds(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    function textFormatDate(dateStr) {
        const date = new Date(dateStr);
        const options = { 
            year: 'numeric', 
            month: 'long', 
            day: 'numeric' 
        };
        const formattedDate = date.toLocaleDateString("en-US", options);
        return formattedDate;
    }

    useEffect(() => {
        fetchData();
        if(payrollPeriodId !== ""){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [payrollPeriodId]);

    const handleSelectChange = (event) => {
        setIsSelected(true);
        setPayrollPeriodId(event.target.value);
        const payrollPeriodSelected = payrollPeriodIds.find(payrollPeriod => payrollPeriod.id === parseInt(event.target.value));
        setPayrollPeriodDescription(`${textFormatDate(payrollPeriodSelected.dateFrom)} to ${textFormatDate(payrollPeriodSelected.dateTo)}`)
    };

    return (
        <div>
            <select id="employee-select-PagibigReport" value={payrollPeriodId} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose payroll period</option>
            {payrollPeriodIds.map((payrollPeriodId) => ( 
                SetPayrollPeriodId(payrollPeriodId)
            ))}
            </select>
        </div>
    );
};
function SetPayrollPeriodId(payrollPeriodId){
    const formattedDateFrom = format(payrollPeriodId.dateFrom, 'MM/dd/yyyy');
    const formattedDateTo = format(payrollPeriodId.dateTo, 'MM/dd/yyyy');

    return(
        <option value={payrollPeriodId.id}>{`${formattedDateFrom} - ${formattedDateTo} ${payrollPeriodId.payTypeDescription ? payrollPeriodId.payTypeDescription : ""}`}
        </option>
    )
}
function CompanyTypeSelect({companyId, setCompanyId, setCompany}){
    const [isSelected, setIsSelected] = useState(false);

    const handleSelectChange = (event) => {
        setIsSelected(true);

        const selectedCompanyId = event.target.value; // Get the selected company ID
        setCompanyId(selectedCompanyId);
        const selectedCompany = data.find((comp) => comp.id.toString() === selectedCompanyId.toString()); // Find the full company object

        if (selectedCompany) {
            setCompany(selectedCompany); // Set the full company object
        }
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Company/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            response.data.sort((a, b) => a.name.localeCompare(b.name));
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if (companyId !== "" && companyId !== 0 && companyId !== null && companyId !== undefined && companyId.length !== 0) {
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [companyId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={companyId || ""} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose company type</option>
            {data.map((companyId) => ( 
                SetCompanyType(companyId)
            ))}
            </select>
        </div>
    );
};
function SetCompanyType(company){
    return(
        <option value={company.id}>{
            company.name}
        </option>
    )

}
export default CostCenterReport
